import { IRole } from '@/app/types/authType'
// import { TListKind } from '@/app/types/dmsTypes'
// import { type TRole } from '@App/types/common'
import { type IDoctorFilters } from '@App/types/doctorsType'

export const routes: Record<string, string> = {
    HOME: '/home',
    FAQS: '/faq',
    DOCS: '/doctors',
    SRVS: '/services',
    ADMN: '/admins',
    AUTH: '/auth',
    STGS: '/settings',
    DMSM: '/dms-manager'
}

export const ERRORS_HANDLER: Record<number, string> = {
    400: 'Неверный запрос (400)',
    401: 'Требуется авторизация (401)',
    403: 'Недостаточно прав выполнить операцию (403)',
    404: 'Запрос не найден (404)',
    409: 'Конфликт (409)',
    500: 'Серверная проблема (500)'
}

export const headerExcludedRoutes = ['auth']

// default filters ...
export const defaultDoctorsFilters: IDoctorFilters = {
    post: null,
    photo: 'all',
    description: 'all',
    search: '',
    limit: 16,
    offset: 0
}

export const defaultFaqFilters = { search: '' }

// export const defaultDmsFilters = { mode: 'insureds' as TListKind }

export const defaultServicesFilters = { category: null, search: '' }

export const ROLE_MAPPER: Record<string, IRole> = {
    SADMN: {
        role: 'SUPER_ADMINISTRATOR',
        roleDescription: 'Супер-Администратор'
    },
    RADMN: {
        role: 'ADMINISTRATOR',
        roleDescription: 'Администратор'
    },
    DMSMR: {
        role: 'DMS_ADMINISTRATOR',
        roleDescription: 'Администрирование данных ДМС'
    },
    UNKNOWN: {
        role: 'UNKNOWN',
        roleDescription: 'Не известная роль'
    }
}

export const API_URL = `/api`
export const ADMINS_URL = `/admins`

export const IMAGE_BASE_URL = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL.slice(0, -1) : ''

export const OTHERS_CATEGORY_ID = '00000000-0000-0000-0000-000000000000'

export const BLANC_IMAGE_URL = `${IMAGE_BASE_URL}/api/storage/img-2a680928-03b0-4ccb-ae99-9be7b4b879c0.jpg`

export const APP_LOGO = `${IMAGE_BASE_URL}/api/storage/logo.png`

export const DEFAULT_LINKS = {
    offer: `130eb4dc-2d6a-4315-a20c-9a3a6e67e0cd.pdf`,
    attorney: `95c593c8-0ae5-4aa9-bf2e-cc18dd095249.pdf`,
    policy: `99f4c4b5-da65-4b35-97a0-34ff230a57d5.pdf`
}
